import React from "react";
import classnames from "classnames";
import styles from "./card-carousel.module.scss";

export const CarouselDots = ({
  pagingDotsIndices,
  currentSlide,
  goToSlide,
}) => (
  <ul className={styles.dotsList}>
    {
      // pagingDotsIndices items can be decimals, so index is used instead
      pagingDotsIndices.map((item, index) => (
        <li key={item}>
          <button
            className={classnames(
              `${
                Math.ceil(currentSlide) === index
                  ? styles.activeDot
                  : styles.inactiveDot
              }`,
              styles.dotButton
            )}
            type="button"
            aria-label={`slide ${index + 1} bullet`}
            onClick={() => goToSlide(index)}
          />
        </li>
      ))
    }
  </ul>
);

CarouselDots.displayName = "CarouselDots";
